import { render, staticRenderFns } from "./dialog-login-sharelink.vue?vue&type=template&id=2c2cf2b7&"
import script from "./dialog-login-sharelink.vue?vue&type=script&lang=js&"
export * from "./dialog-login-sharelink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports